export const breakpoints = {
  desktop: {
    width: 1200
  },
  tabletls: {
    width: 1024,
    horizontalPadding: 20
  },
  tablet: {
    width: 768,
    horizontalPadding: 20
  },
  mobile: {
    width: 375,
    horizontalPadding: 20
  }
};